import { Component} from '@angular/core';


@Component({
  /**
   * Component Selector
   */
  selector: 'crem-loader',
  template:  ` <dx-load-indicator id="medium-indicator" color="#033871" height="60" width="60"></dx-load-indicator>`,
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent{



    constructor() {
}



}
